import {
  REQUEST_CATEGORY_LIST,
  REMOVE_CATEGORIES
} from './mutation-types';
  
import axiosInst from '@/utility/axiosInst';
  
export default {
  requestCategoryList({commit}, categoryParent) {
    return axiosInst.springAxiosInst.get("/category/get-list", {
      params: {
        categoryParent: categoryParent,
      }
    }).then((res) => {
      commit(REQUEST_CATEGORY_LIST, res.data)
    })
  },

  removeCategories({commit}) {
    return commit(REMOVE_CATEGORIES)
  }
}